import React from 'react';
import { compose, pure, withStateHandlers } from 'recompose';
import PropTypes from 'prop-types';
import { CommentsModel } from '../../../model';
import {
  StyledWrapperComment,
  StyleAnswer,
  StyleButtons,
  StyleDateFormat,
  StyleFormAnswer,
  StyleInfo,
  StyleRead,
  StyleTextComment,
  StyledComment,
  StyledWrapAvatar,
  StyleButtonsContainer
} from './styleComment';
import { StyleTextArea } from './styleNewsComments';
import AvatarComments from '../../core/AvatarComments';
import Icon from '../../core/Icon';
import { Trash } from '../../../../assets/images';

const lengthText = 250;

const Comment = ({
  className,
  comment,
  children,
  reply,
  toggleAnswer,
  updateAnswer,
  answerId,
  sendAnswer,
  canAnswerAsA3Mil,
  secondary,
  answer,
  readMore,
  toggleReadMore,
  userId,
  canDelete,
  onDelete
}) => (
  <StyledWrapperComment className={className} secondary={secondary}>
    <StyledWrapAvatar>
      <AvatarComments
        name={comment.username}
        lastname={comment.userlastname}
        userId={userId}
        avatarPhoto={comment.avatarPhoto}
      />
    </StyledWrapAvatar>
    <StyledComment secondary={secondary}>
      <StyleInfo>
        <span>
          {' '}
          <StyleDateFormat format="DD/MM/YY">{comment.date}</StyleDateFormat>
          {`${comment.username} ${comment.userlastname}`}
        </span>
        {canDelete && (
          <Icon hover size="s" color="error" svg={Trash} onClick={onDelete} />
        )}
      </StyleInfo>
      <StyleTextComment
        maxlength={lengthText}
        text={comment.text}
        disabled={readMore}
      />

      {reply && (
        <StyleAnswer
          onClick={() => toggleAnswer(comment.id)}
          answerId={answerId === comment.id}
        >
          Responder
        </StyleAnswer>
      )}

      {comment.text.length >= lengthText && (
        <StyleRead onClick={toggleReadMore} inactive={readMore}>
          {readMore ? 'Leer menos' : 'Leer más'}
        </StyleRead>
      )}

      {reply && answerId === comment.id && (
        <StyleFormAnswer>
          <StyleTextArea
            area
            name="responder"
            rows={2}
            multiline
            value={answer}
            onChange={updateAnswer}
            autoFocus
          />
          <StyleButtonsContainer>
            {/* Funcion flecha: si se pasa sendAnswer directo recibe el evento */}
            <StyleButtons ghost onClick={() => sendAnswer()} disabled={!answer}>
              Responder
            </StyleButtons>
            {canAnswerAsA3Mil && (
              <StyleButtons
                ghost
                onClick={() => sendAnswer({ generic: true })}
                disabled={!answer}
              >
                Responder como A3Mil
              </StyleButtons>
            )}
          </StyleButtonsContainer>
        </StyleFormAnswer>
      )}
    </StyledComment>
    {children}
  </StyledWrapperComment>
);

Comment.propTypes = {
  className: PropTypes.string,
  comment: CommentsModel,
  children: PropTypes.node,
  reply: PropTypes.bool,
  secondary: PropTypes.bool,
  toggleAnswer: PropTypes.func,
  updateAnswer: PropTypes.func,
  answerId: PropTypes.string,
  sendAnswer: PropTypes.func,
  canAnswerAsA3Mil: PropTypes.bool,
  answer: PropTypes.string,
  toggleReadMore: PropTypes.func,
  readMore: PropTypes.bool,
  userId: PropTypes.string,
  canDelete: PropTypes.bool,
  onDelete: PropTypes.func
};

export default compose(
  withStateHandlers(
    { readMore: false },
    { toggleReadMore: ({ readMore }) => () => ({ readMore: !readMore }) }
  ),
  pure
)(Comment);
